import * as Models from "../models/models";

export const mods = [
  {
    id: 1,
    parentId: 0,
    metaData: "",
    name: "Bridges",
  },
  {
    id: 11,
    parentId: 1,
    metaData: "",
    name: "Footbridge",
  },
  {
    id: 12,
    parentId: 1,
    metaData: "",
    name: "Traffic",
  },
  //
  {
    id: 2,
    parentId: 0,
    metaData: "",
    name: "Footpath",
  },
  {
    id: 21,
    parentId: 2,
    metaData: "",
    name: "Unsealed Footpath-Gravel75",
  },
  {
    id: 22,
    parentId: 2,
    metaData: "",
    name: "Sealed Footpath-UNRConcrete75",
  },
  //
  {
    id: 3,
    parentId: 0,
    metaData: "",
    name: "Roads",
  },
  {
    id: 31,
    parentId: 3,
    metaData: "",
    name: "Unsealed Road-Formation",
  },
  {
    id: 32,
    parentId: 3,
    metaData: "",
    name: "Sealed Road-CR-100mm",
  },
  {
    id: 301,
    parentId: 31,
    metaData: "",
    name: "Earthwork",
  },
  {
    id: 302,
    parentId: 32,
    metaData: "",
    name: "Pavement Base/ Sub Base Course",
  },
  //
  {
    id: 4,
    parentId: 0,
    metaData: "",
    name: "Retaining Walls",
  },
  {
    id: 41,
    parentId: 4,
    metaData: "",
    name: "Precast - Cantilever Retaining Wall",
  },
  {
    id: 42,
    parentId: 4,
    metaData: "",
    name: "Gabion - Retaining Wall",
  },
];

export const inputs: Models.InputElement[] = [
  {
    id: 1,
    name: "Regional Factor",
    type: "Number Input",
    default: "1.20",
  },
  {
    id: 2,
    name: "Footpath Type",
    type: "Dropdown",
    default: "Asphalt",
    inputConfig: {
      options: ["Asphalt", "Unreinforced Concrete", "Reinforced Concrete", "Pavers"],
    },
  },
  {
    id: 3,
    name: "Base Depth",
    type: "Dropdown",
    default: "50",
    inputConfig: {
      options: ["75mm", "80mm", "90mm"],
    },
  },
  {
    id: 8,
    name: "Surface Type",
    type: "Dependent Dropdown",
    default: "",
    inputConfig: {
      dependentColumn: ["2"],
      dependentOptions: [
        {
          keys: [
            {
              column: "Footpath Type",
              value: "Asphalt",
            },
          ],
          options: ["25mm Asphalt", "30mm Asphalt"],
        },
        {
          keys: [
            {
              column: "Footpath Type",
              value: "Unreinforced Concrete",
            },
          ],
          options: ["75mm Concrete", "100mm Concrete"],
        },
        {
          keys: [
            {
              column: "Footpath Type",
              value: "Reinforced Concrete",
            },
          ],
          options: ["100mm Concrete", "150mm Concrete", "75mm Concrete"],
        },
        {
          keys: [
            {
              column: "Footpath Type",
              value: "Pavers",
            },
          ],
          options: ["230x110/150x75 Brick", "Urbanstone shotblast finish, Cat A-D", "Urbanstone shotblast finish, Cat E"],
        },
      ],
    },
  },
  { id: 5, name: "Renewal Area", type: "Number Input", default: "500" },
  { id: 6, name: "Base Recycle", type: "Number Input", default: "" },
  { id: 7, name: "Over Head %", type: "Number Input", default: "3.00" },
];

export const formulas: Models.FormulaElement[] = [
  {
    id: 1,
    key: "[Removal of existing footpath surface]",
    name: "Removal of existing footpath surface",
    type: "Look Up",
    group: "group1",
    comment: "",
  },
  { id: 2, group: "group1", key: "[Removal of existing base (cut in clay)]", name: "Removal of existing base (cut in clay)", type: "Look Up", comment: "" },
  {
    id: 3,
    key: "[Disposal of surface (density 2t/m3)(Mixture)]",
    name: "Disposal of surface (density 2t/m3)(Mixture)",
    type: "Look Up",
    group: "group1",
    comment: "",
  },
  {
    id: 4,
    key: "[Regional Factor]",
    name: "Regional Factor",
    type: "Fixed Value",
    group: "group2",
    comment: "",
  },
  {
    id: 5,
    key: "[Removal of existing footpath surface Qty]",
    name: "Removal of existing footpath surface Qty",
    type: "Formula",
    group: "group12",
    comment: "",
  },
];
